import { getFieldsToValidateByStep } from './getFieldsToValidateByStep';

export function getPreviousErrorsByStep({
  steps,
  currentStep,
  errors,
}: // oxlint-disable-next-line typescript/no-explicit-any
any): string[][] {
  const errorsByStep = getFieldsToValidateByStep(steps, currentStep - 1);

  return errorsByStep.map((step) =>
    Object.keys(errors).filter((errorName) => step.includes(errorName)),
  );
}
